import {Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";

export const ToolTip = withStyles({
    tooltip: {
        color: "#fff",
        backgroundColor: "orange",
        padding: '16px 14px 16px 14px',
        boxShadow: '0 1rem 3rem rgba(0, 0, 0, .175) !important',
        borderRadius: '12px !important',
        fontWeight: 500,
        fontSize: '14px'
    },
    arrow: {
        color: "orange",
        boxShadow: '0 1rem 3rem rgba(0, 0, 0, .175) !important',
    },
})(Tooltip);



